<div class="modal-wrapper">
  <div class="modal-wrapper__header u-flex u-justify-between u-align-center">
    <h5 mat-dialog-title class="modal-title">{{ data.dialogTitle }}</h5>
    <!-- Close button -->
    <button mat-dialog-close type="button" class="close-btn" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <!-- Modal container -->
  <div class="modal-container u-m-2">
    <div class="modal-content">
      <ng-container #componentContainer></ng-container>
    </div>
  </div>
</div>
